import { Text } from '@audio-network/componentlibrary'
import styled from 'styled-components'

export const TrackInfoStrong = styled(Text)`
	font-weight: 600;
`

export const ActionsWrapper = styled.div`
	display: flex;
	justify-content: end;
`
